import React, { useEffect } from 'react'
import {
  expirationOptions,
  MESSAGE_EXPIRATION_NONE,
} from './useMessageExpiration'
import { FormattedMessage } from 'react-intl'
import { useField, useFormikContext } from 'formik'
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Input,
  InputAdornment,
} from '@material-ui/core'
import clsx from 'clsx'
import { TimeIcon } from 'app/components/icons'
import { TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'
import Selector from 'app/componentV4/Input/Selector'

export default function MessageExpirationSelector(props) {
  const [field, meta, helpers] = useField(props.name)
  const { value } = meta
  const { setValue } = helpers
  const { values } = useFormikContext()

  const shouldDisable =
    values?.notiType === TYPE_EVENT || values?.notiType === TYPE_POLL

  useEffect(() => {
    if (shouldDisable && value !== MESSAGE_EXPIRATION_NONE) {
      setValue(MESSAGE_EXPIRATION_NONE)
      props.onChange?.(MESSAGE_EXPIRATION_NONE)
    }
  }, [shouldDisable, setValue, value, props.onChange])

  return (
    <FormControl
      className={clsx(props.className, 'w-full')}
      variant={props.variant}
      required={props.required}
      disabled={props.disabled || shouldDisable}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <Selector
        {...field}
        disableUnderline={true}
        value={value}
        disabled={props.disabled || shouldDisable}
        className="h-48"
        onChange={(event) => {
          setValue(event.target.value)
          if (props.onChange) {
            props.onChange(event.target.value)
          }
        }}
        startAdornment={
          <InputAdornment position="start">
            <TimeIcon />
          </InputAdornment>
        }
      >
        {expirationOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <FormattedMessage id={option.title} />
          </MenuItem>
        ))}
      </Selector>
    </FormControl>
  )
}
